import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Mail, Lock, LogIn } from 'lucide-react';
import toast from 'react-hot-toast';

const Auth = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Verificar se há uma sessão salva no localStorage
  useEffect(() => {
    try {
      const savedSession = localStorage.getItem('userSession');
      if (savedSession) {
        const sessionData = JSON.parse(savedSession);
        const lastActive = new Date(sessionData.lastActive);
        const now = new Date();
        const hoursDiff = (now - lastActive) / (1000 * 60 * 60);
        
        // Se a última atividade foi há menos de 24 horas, considerar a sessão válida
        if (hoursDiff < 24) {
          console.log('Sessão válida encontrada no localStorage');
        }
      }
    } catch (error) {
      console.error('Erro ao verificar sessão salva:', error);
    }
  }, []);

  // Redirecionar se já estiver autenticado
  useEffect(() => {
    if (user) {
      // Sempre redirecionar para a home após login
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error('Por favor, preencha todos os campos');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const { success, error } = await login(email, password);
      
      if (success) {
        // Navegação será feita pelo useEffect quando o usuário for definido
        // Atualizar a última atividade
        try {
          const savedSession = localStorage.getItem('userSession');
          if (savedSession) {
            const sessionData = JSON.parse(savedSession);
            sessionData.lastActive = new Date().toISOString();
            localStorage.setItem('userSession', JSON.stringify(sessionData));
          }
        } catch (storageError) {
          console.error('Erro ao atualizar última atividade:', storageError);
        }
      } else {
        throw error;
      }
    } catch (error) {
      console.error('Erro de login:', error);
      toast.error(error.message || 'Falha na autenticação. Verifique suas credenciais.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-container" style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      backgroundColor: '#f8f9fa',
      overflow: 'hidden',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }}>
      <div className="auth-card" style={{ 
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '30px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        width: '100%',
        maxWidth: '400px',
        maxHeight: '90vh',
        overflowY: 'auto'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h2 style={{ 
            color: '#333', 
            marginBottom: '10px',
            fontSize: '1.8rem'
          }}>
            Login
          </h2>
          <p style={{ color: '#666' }}>
            Sistema Integrado de Gestão Municipal
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <div style={{ position: 'relative' }}>
              <Mail size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#666' }} />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{ paddingLeft: '40px', width: '100%' }}
                placeholder="seu.email@exemplo.com"
                disabled={isSubmitting}
              />
            </div>
          </div>

          <div className="form-group">
            <label>Senha</label>
            <div style={{ position: 'relative' }}>
              <Lock size={18} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#666' }} />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ paddingLeft: '40px', width: '100%' }}
                placeholder="Sua senha"
                disabled={isSubmitting}
              />
            </div>
          </div>

          <button 
            type="submit" 
            className="button" 
            disabled={isSubmitting}
            style={{ 
              width: '100%', 
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <LogIn size={18} />
            {isSubmitting ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '14px', color: '#666' }}>
          <p>Entre em contato com o administrador do sistema para obter acesso.</p>
        </div>
      </div>
    </div>
  );
};

export default Auth;